import { lazy, Suspense } from 'react';
import { Route, Routes as ReactRoutes } from 'react-router-dom';
import Loading from './components/Loading';
import { Illustrations } from './components/Illustrations/Illustrations';
import { Temoins } from './components/Temoins/Temoins';
import MaquetteLot from './components/Lot/MaquetteLot';
import VisiteLot from './components/Lot/VisiteLot';
import PlanLot from './components/Lot/PlanLot';
import { Contact } from './components/Contact/Contact';
import GoogleMapReact from 'google-map-react';
import Box from '@mui/material/Box';
import { LotMaquetteSituation } from './components/Lot/LotMaquetteSituation';

const Programme = lazy(() => import('./components/Programme'));
const Lot = lazy(() => import('./components/Lot'));
const Photoloc = lazy(() => import('./components/Photoloc'));
const GoogleMaps = lazy(() => import('./components/GoogleMaps'));
const Visite = lazy(() => import('./components/Visite'));
const Recherche = lazy(() => import('./components/Recherche'));
const MaquetteExt = lazy(() => import('./components/Maquette/MaquetteExt'));
const ProfilLayout = lazy(() => import('./components/Profil/ProfilLayout'));
const Favorites = lazy(() => import('./components/Profil/Favorites'));
const Preferences = lazy(() => import('./components/Profil/Preferences'));
const Accueil = lazy(() => import('./components/Accueil/Accueil'));

const Routes = () => (
  <ReactRoutes>
    <Route
      path="/mapTest"
      element={
        <Box sx={{ height: '100vh' }}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: process.env.REACT_APP_MAPS_API_KEY,
              libraries: ['places', 'geometry'],
            }}
            defaultCenter={{ lat: 46.85023939245115, lng: -1.8783217306552773 }}
            defaultZoom={18}
            yesIWantToUseGoogleMapApiInternals={true}
            options={{
              styles: [],
              mapTypeId: 'roadmap',
              mapTypeControl: true,
              streetViewControl: true,
            }}
          />
        </Box>
      }
    ></Route>
    <Route
      path="/:mediaPath"
      element={
        <Suspense fallback={<Loading />}>
          <Programme />
        </Suspense>
      }
    >
      <Route
        path="accueil"
        element={
          <Suspense fallback={<Loading />}>
            <Accueil />
          </Suspense>
        }
      ></Route>
      <Route
        path="maquette/:mediaName"
        element={
          <Suspense fallback={<Loading />}>
            <MaquetteExt />
          </Suspense>
        }
      ></Route>
      <Route
        path="maquette/:mediaName/:variation"
        element={
          <Suspense fallback={<Loading />}>
            <MaquetteExt />
          </Suspense>
        }
      ></Route>
      <Route
        path="maquette"
        element={
          <Suspense fallback={<Loading />}>
            <MaquetteExt />
          </Suspense>
        }
      ></Route>
      <Route
        path="lot/:lotName"
        element={
          <Suspense fallback={<Loading />}>
            <Lot />
          </Suspense>
        }
      >
        <Route
          path="maquette"
          element={
            <Suspense fallback={<Loading />}>
              <MaquetteLot />
            </Suspense>
          }
        />
        <Route
          path="plan"
          element={
            <Suspense fallback={<Loading />}>
              <PlanLot />
            </Suspense>
          }
        />
        <Route
          path="visite/*"
          element={
            <Suspense fallback={<Loading />}>
              <VisiteLot />
            </Suspense>
          }
        />
        <Route
          path="situation"
          element={
            <Suspense fallback={<Loading />}>
              <LotMaquetteSituation />
            </Suspense>
          }
        />
      </Route>
      <Route
        path="map"
        element={
          <Suspense fallback={<Loading />}>
            <GoogleMaps />
          </Suspense>
        }
      ></Route>
      <Route
        path="photoloc"
        element={
          <Suspense fallback={<Loading />}>
            <Photoloc />
          </Suspense>
        }
      ></Route>
      <Route
        path="visite/:mediaName"
        element={
          <Suspense fallback={<Loading />}>
            <Visite />
          </Suspense>
        }
      ></Route>

      <Route
        path="visite"
        element={
          <Suspense fallback={<Loading />}>
            <Visite />
          </Suspense>
        }
      ></Route>

      <Route
        path="recherche"
        element={
          <Suspense fallback={<Loading />}>
            <Recherche />
          </Suspense>
        }
      ></Route>

      <Route
        path="illustrations"
        element={
          <Suspense fallback={<Loading />}>
            <Illustrations />
          </Suspense>
        }
      ></Route>

      <Route
        path="temoins"
        element={
          <Suspense fallback={<Loading />}>
            <Temoins />
          </Suspense>
        }
      ></Route>
      <Route
        path="temoins/:temoinId"
        element={
          <Suspense fallback={<Loading />}>
            <Temoins />
          </Suspense>
        }
      >
        <Route
          path="maquette"
          element={
            <Suspense fallback={<Loading />}>
              <MaquetteLot />
            </Suspense>
          }
        />
      </Route>
      <Route
        path="profil"
        element={
          <Suspense fallback={<Loading />}>
            <ProfilLayout />
          </Suspense>
        }
      >
        <Route
          path="favorites"
          element={
            <Suspense fallback={<Loading />}>
              <Favorites />
            </Suspense>
          }
        />

        <Route
          path="preferences"
          element={
            <Suspense fallback={<Loading />}>
              <Preferences />
            </Suspense>
          }
        />
      </Route>
      <Route
        path="contact"
        element={
          <Suspense fallback={<Loading />}>
            <Contact />
          </Suspense>
        }
      />
    </Route>
  </ReactRoutes>
);

export default Routes;
